import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const userAccountIcon = () => (
  <svg
    width="40"
    height="45"
    viewBox="0 0 40 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#F6F6F6" />
    <path
      d="M27.7782 28.75V26.8056C27.7782 25.7742 27.3685 24.785 26.6392 24.0557C25.9099 23.3264 24.9207 22.9167 23.8893 22.9167H16.1115C15.0801 22.9167 14.091 23.3264 13.3617 24.0557C12.6324 24.785 12.2227 25.7742 12.2227 26.8056V28.75M23.8893 15.1389C23.8893 17.2867 22.1482 19.0278 20.0004 19.0278C17.8527 19.0278 16.1115 17.2867 16.1115 15.1389C16.1115 12.9911 17.8527 11.25 20.0004 11.25C22.1482 11.25 23.8893 12.9911 23.8893 15.1389Z"
      stroke="#F26533"
      stroke-width="2.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 34C17.24 34 15 36.24 15 39C15 41.76 17.24 44 20 44C22.76 44 25 41.76 25 39C25 36.24 22.76 34 20 34ZM20 43C17.795 43 16 41.205 16 39C16 36.795 17.795 35 20 35C22.205 35 24 36.795 24 39C24 41.205 22.205 43 20 43ZM22.295 36.79L19 40.085L17.705 38.795L17 39.5L19 41.5L23 37.5L22.295 36.79Z"
      fill="#49BB62"
    />
  </svg>
);

export const UserAccountIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={userAccountIcon} {...props} />
);
